import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

/**
 * Warns the user before losing unsaved changes, both when closing/refreshing
 * the tab and when navigating to another page inside the app.
 * @param isDirty - whether there are unsaved changes
 */
export function useUnsavedChanges(isDirty: boolean) {
  // Tab close / refresh
  useEffect(() => {
    if (!isDirty) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);

  // In-app navigation (sidebar links, back button, etc.)
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (blocker.state !== 'blocked') return;
    const leave = window.confirm(
      'You have unsaved changes. Leave this page and discard them?',
    );
    if (leave) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker]);
}
